package cc.bluepeak.clubmanager.site.styles

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.px

object Theme {
    val primary = Color.rgb(0x266CF8)
    val secondary = Color.rgb(154, 154, 154)
    val lightBackground = Color.rgb(234, 234, 239)
    val darkBackground = Color.rgb(36, 39, 43)
    val white = Color.rgb(255, 255, 255)
    val black = Color.rgb(0, 0, 0)
    val lightSurface = Color.rgb(255, 255, 255)
    val darkSurface = Color.rgb(25, 26, 28)
    val lightSurfaceVariant = Color.rgb(242, 242, 242)
    val darkSurfaceVariant = Color.rgb(39, 41, 41)

    object shapes {
        val small = 6.px
        val medium = 8.px
    }
}

data class SitePalette(
    val primary: Color,
    val secondary: Color,
    val background: Color,
    val surface: Color,
    val surfaceVariant: Color,
)

object SitePalettes {
    var light: SitePalette = SitePalette(
        primary = Theme.primary,
        secondary = Theme.secondary,
        background = Theme.lightBackground,
        surface = Theme.lightSurface,
        surfaceVariant = Theme.lightSurfaceVariant
    )
    var dark: SitePalette = SitePalette(
        primary = Theme.primary,
        secondary = Theme.secondary,
        background = Theme.darkBackground,
        surface = Theme.darkSurface,
        surfaceVariant = Theme.darkSurfaceVariant
    )
}

fun ColorMode.toSitePalette() = when (this) {
    ColorMode.LIGHT -> SitePalettes.light
    ColorMode.DARK -> SitePalettes.dark
}